import { NoContextImage } from "@/components/Image";
import { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom";
import Video from "yet-another-react-lightbox/dist/plugins/video";

const INIT_STATE = {
    gallery: {isOpen: false, index: 0}
}

const MediaGallery = forwardRef((props, ref) => {
    const [settings, setSettings] = useState(INIT_STATE.gallery);
    const {
        media, 
        onImageIndexChange, 
        actions, 
        methods = {

        }
    } = props;

    const mediaGalleryRef = useRef(null);
    const fullscreenRef = useRef(null);
    const zoomRef = useRef(null);
 
    const onClose = () => setSettings(INIT_STATE.gallery);
    const onOpen = (index = 0) => setSettings({isOpen: true, index: index});
    const onFullscreen = () => fullscreenRef.current?.enter();

    useImperativeHandle(ref, () => ({
        open: (index = 0) => onOpen(index)
    }), [mediaGalleryRef]);

    const handleUpdateInex = ({index}) => {
        if (typeof onImageIndexChange === 'function') onImageIndexChange(index);
    }

    const parsedMedia = useMemo(() => media?.map((item) => {

        //Video
        if (item?.mediaType?.includes('video')) {
            return {
                type: 'video',
                poster: item.uri + '.thumb.jpg',
                downloadUrl: item?.uri, 
                share: item?.uri,
                sources: [
                    {src: item?.uri, type: item?.mediaType}
                ],
            };
        }

        //default Image
        return {
            ...item,
            src: item?.uri, 
            downloadUrl: item?.uri, 
            share: item?.uri,
            type: undefined, 
        };

    }), [media]);

    const plugIns = useMemo(() => {
        
        const plugins = [Fullscreen, Zoom];

        if (actions?.includes('video')) plugins.push(Video);
        
        if (media?.find(item => item?.uri?.includes('preview_'))) 
            return plugins;
            
        return plugins;
    }, [actions, media]);

    return (
        <Lightbox
            slides={parsedMedia}
            index={settings?.index ?? 0}
            open={settings?.isOpen}
            close={onClose}
            fullscreen={{ ref: fullscreenRef }} 
            zoom={{ ref: zoomRef }}
            plugins={plugIns}
            on={{
                click: onFullscreen,
                view: handleUpdateInex
            }}
            render={{
                slide: ({ slide, rect }) => (
                    <NoContextImage
                        key={slide.src}
                        source={{uri: slide.src}}
                        width={rect.width}
                        height={rect.height}
                        contentFit={"contain"}
                        loading={'lazy'}
                        alt={slide.alt ?? ""}
                        style={{
                            width: rect.width,
                            height: rect.height,
                            objectFit: "contain",
                        }}
                        draggable={false}
                    />
                ),
            }}
        />
    )

});

export default MediaGallery;